var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#590577",
    d: "m11.532 9.99l.716-.214l.214.72l-.72.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D5F90",
    d: "m11.717 10.089l.428-.129l.129.429l-.429.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#590577",
    d: "m12.938 10.423l.42-.124l.124.42l-.42.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D5F90",
    d: "m13.092 10.509l.185-.056l.055.184l-.184.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#590577",
    fillRule: "evenodd",
    d: "m12.137 12.746l-.42.12l.128.42l.416-.124zm-.082.15l-.184.055l.056.185l.184-.056zm-.664-1.877l-.917.27l.27.917l.917-.27zm-.129.244l-.544.159l.159.54l.54-.16l-.159-.54zm-.454 1.513l-.694.206l.206.694l.694-.206zm-.103.184l-.407.124l.12.408l.407-.12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#590577",
    d: "m12.458 11.816l.532-.155l.154.528l-.532.158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D5F90",
    d: "m12.651 11.923l.231-.069l.069.232l-.231.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#590080",
    fillRule: "evenodd",
    d: "M12 19.286a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572m0-.857a6.429 6.429 0 1 0-3.746-1.205a.163.163 0 0 1 .077-.244l.111-1.101l2.045-1.415l.064.086l-2.001 1.39l-.108 1.041a.163.163 0 1 1-.094.313A6.4 6.4 0 0 0 12 18.429m3.334-11.657c-.15.29-.81.887-2.229.964l-1.384 1.56l.133.128l1.204-1.414c.244.249.652.643 1.072 1.024l-.455.523l.129.116l.45-.531c.364.32.728.612.994.762l-1.414 1.869l.137.081l1.453-1.868c.013-.043.026-.21-.034-.514c-.078-.386-.12-1.428.608-2.118c-.073-.445-.471-.574-.664-.583m-5.61 5.442l.094.06l-1.281 1.963v.776a.163.163 0 1 1-.107 0v-.81zm-1.244 3.01a.06.06 0 0 0 .049-.01a.056.056 0 0 0 0-.088a.056.056 0 0 0-.078.01a.056.056 0 0 0 .029.088m-.039 1.911a.056.056 0 1 1-.106.031a.056.056 0 0 1 .106-.03m3.875-3.218l-1.44 1.705l-1.397.862v.026a.163.163 0 1 1-.052-.12l1.376-.853l1.431-1.693zm-3 2.648a.056.056 0 1 0 .025-.108a.06.06 0 0 0-.054.021a.056.056 0 0 0 .029.087",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrt);
export default __webpack_public_path__ + "static/media/ort.e6425cd35a93a184c2b6318fb78f4340.svg";
export { ForwardRef as ReactComponent };